/**
 * Share palettes between rings and cards to prevent drift. Colors belong to theme tokens in
 * css/tokens/guided-setup.css, not API payloads; vary intensity so adjacent arcs remain distinguishable.
 */
import type { ContextDimensionId } from "~vue/ProfileSetup/types";

export interface RingPalette {
    /** The dimension's arc, and the solid mark beside its label. */
    dot: string;
}

const RING_PALETTES: Record<ContextDimensionId, RingPalette> = {
    company: { dot: "var(--color-setup-ring-company)" },
    you: { dot: "var(--color-setup-ring-you)" },
    team: { dot: "var(--color-setup-ring-team)" },
};

const FALLBACK: RingPalette = RING_PALETTES.company;

export function ringPalette(id: string): RingPalette {
    return RING_PALETTES[id as ContextDimensionId] ?? FALLBACK;
}
